import PlaceHolder from "assets/images/placeholder2.jpg";

const songReference = "https://www.kozco.com/tech/piano2-CoolEdit.mp3";

// Upload Module
export const getPlaceHolder = () => {
  return PlaceHolder;
};

export const getSongReference = () => {
  return songReference;
};

export const pagination = () => {
  return { page: 1, pageSize: 10, pageCount: 1 };
};

export const families = () => {
  return [
    {
      id: 1,
      firstName: "John",
      lastName: "Mike",
      relationship: "Father",
      photo: PlaceHolder,
    },
    {
      id: 2,
      firstName: "Kelly",
      lastName: "Mike",
      relationship: "Mother",
      photo: PlaceHolder,
    },
    {
      id: 3,
      firstName: "Richard",
      lastName: "Mike",
      relationship: "Brother",
      photo: PlaceHolder,
    },
    {
      id: 4,
      firstName: "Kime",
      lastName: "Mike",
      relationship: "Sister",
      photo: PlaceHolder,
    },
    {
      id: 5,
      firstName: "Rock",
      lastName: "Mike",
      relationship: "Grand-Father",
      photo: PlaceHolder,
    },
  ];
};

export const events = () => {
  return [
    {
      id: 1,
      name: "Tea Party",
      location: "London",
      year: "2019",
      photo: PlaceHolder,
    },
    {
      id: 2,
      name: "Tea Party",
      location: "London",
      year: "2019",
      photo: PlaceHolder,
    },
    {
      id: 3,
      name: "Tea Party",
      location: "London",
      year: "2019",
      photo: PlaceHolder,
    },
    {
      id: 4,
      name: "Tea Party",
      location: "London",
      year: "2019",
      photo: PlaceHolder,
    },
    {
      id: 5,
      name: "Tea Party",
      location: "London",
      year: "2019",
      photo: PlaceHolder,
    },
  ];
};

export const items = () => {
  return [
    {
      id: 1,
      name: "Toy",
      color: "Red",
      photo: PlaceHolder,
    },
    {
      id: 2,
      name: "Toy",
      color: "Red",
      photo: PlaceHolder,
    },
    {
      id: 3,
      name: "Toy",
      color: "Red",
      photo: PlaceHolder,
    },
    {
      id: 4,
      name: "Toy",
      color: "Red",
      photo: PlaceHolder,
    },
    {
      id: 5,
      name: "Toy",
      color: "Red",
      photo: PlaceHolder,
    },
  ];
};

export const reminder = () => {
  return [
    {
      id: 1,
      title: "Toy",
      reminder: "9:00 AM",
    },
    {
      id: 2,
      title: "Toy",
      reminder: "9:00 AM",
    },
    {
      id: 3,
      title: "Toy",
      reminder: "9:00 AM",
    },
    {
      id: 4,
      title: "Toy",
      reminder: "9:00 AM",
    },
    {
      id: 5,
      title: "Toy",
      reminder: "9:00 AM",
    },
  ];
};

export const behavioural = () => {
  return [
    {
      id: 1,
      breakfastIntakeTime: "08:00 AM",
      lunchIntakeTime: "2:30 AM",
      dinnerIntakeTime: "6:00 PM",
      otherIntakeTime: null,
      breakfast1: "CEREAL",
      breakfast2: "APPLE",
      breakfast3: "SANDWICH",
      lunch1: "SALAD",
      lunch2: "FISH",
      lunch3: null,
      dinner1: "MILK",
      dinner2: "CEREAL",
      dinner3: "CURRY",
      other: null,
      sleepTime: "9:30 PM",
      sleepDuration: "4",
      sleeper: "TRUE",
      exercise: "EVERYDAY",
      walk: "EVERYDAY",
      miles: "1",
      medication: "REGULARLY",
      hobbies: "WATCHING TV",
    },
    {
      id: 2,
      breakfastIntakeTime: "08:00 AM",
      lunchIntakeTime: "2:30 AM",
      dinnerIntakeTime: "6:00 PM",
      otherIntakeTime: null,
      breakfast1: "CEREAL",
      breakfast2: "APPLE",
      breakfast3: "SANDWICH",
      lunch1: "SALAD",
      lunch2: "FISH",
      lunch3: null,
      dinner1: "MILK",
      dinner2: "CEREAL",
      dinner3: "CURRY",
      other: null,
      sleepTime: "9:30 PM",
      sleepDuration: "4",
      sleeper: "TRUE",
      exercise: "EVERYDAY",
      walk: "EVERYDAY",
      miles: "1",
      medication: "REGULARLY",
      hobbies: "WATCHING TV",
    },
    {
      id: 3,
      breakfastIntakeTime: "08:00 AM",
      lunchIntakeTime: "2:30 AM",
      dinnerIntakeTime: "6:00 PM",
      otherIntakeTime: null,
      breakfast1: "CEREAL",
      breakfast2: "APPLE",
      breakfast3: "SANDWICH",
      lunch1: "SALAD",
      lunch2: "FISH",
      lunch3: null,
      dinner1: "MILK",
      dinner2: "CEREAL",
      dinner3: "CURRY",
      other: null,
      sleepTime: "9:30 PM",
      sleepDuration: "4",
      sleeper: "TRUE",
      exercise: "EVERYDAY",
      walk: "EVERYDAY",
      miles: "1",
      medication: "REGULARLY",
      hobbies: "WATCHING TV",
    },
    {
      id: 4,
      breakfastIntakeTime: "08:00 AM",
      lunchIntakeTime: "2:30 AM",
      dinnerIntakeTime: "6:00 PM",
      otherIntakeTime: null,
      breakfast1: "CEREAL",
      breakfast2: "APPLE",
      breakfast3: "SANDWICH",
      lunch1: "SALAD",
      lunch2: "FISH",
      lunch3: null,
      dinner1: "MILK",
      dinner2: "CEREAL",
      dinner3: "CURRY",
      other: null,
      sleepTime: "9:30 PM",
      sleepDuration: "4",
      sleeper: "TRUE",
      exercise: "EVERYDAY",
      walk: "EVERYDAY",
      miles: "1",
      medication: "REGULARLY",
      hobbies: "WATCHING TV",
    },
    {
      id: 5,
      breakfastIntakeTime: "08:00 AM",
      lunchIntakeTime: "2:30 AM",
      dinnerIntakeTime: "6:00 PM",
      otherIntakeTime: null,
      breakfast1: "CEREAL",
      breakfast2: "APPLE",
      breakfast3: "SANDWICH",
      lunch1: "SALAD",
      lunch2: "FISH",
      lunch3: null,
      dinner1: "MILK",
      dinner2: "CEREAL",
      dinner3: "CURRY",
      other: null,
      sleepTime: "9:30 PM",
      sleepDuration: "4",
      sleeper: "TRUE",
      exercise: "EVERYDAY",
      walk: "EVERYDAY",
      miles: "1",
      medication: "REGULARLY",
      hobbies: "WATCHING TV",
    },
  ];
};

export const schedules = () => {
  return [
    {
      id: 1,
      task: "Wake Up",
      time: "6:30 AM",
    },
    {
      id: 2,
      task: "Wake Up",
      time: "6:30 AM",
    },
    {
      id: 3,
      task: "Wake Up",
      time: "6:30 AM",
    },
    {
      id: 4,
      task: "Wake Up",
      time: "6:30 AM",
    },
    {
      id: 5,
      task: "Wake Up",
      time: "6:30 AM",
    },
  ];
};

export const songs = () => {
  return [
    {
      id: 1,
      name: "Raj",
      songReference,
    },
    {
      id: 2,
      name: "Raj",
      songReference,
    },
    {
      id: 3,
      name: "Raj",
      songReference,
    },
    {
      id: 4,
      name: "Raj",
      songReference,
    },
    {
      id: 5,
      name: "Raj",
      songReference,
    },
  ];
};

export const taskOptions = () => {
  return [
    {
      id: 1,
      name: "Wake Up",
    },
    {
      id: 2,
      name: "Exercise",
    },
    {
      id: 3,
      name: "Breakfast",
    },
    {
      id: 4,
      name: "Lunch",
    },
    {
      id: 5,
      name: "Tea",
    },
    {
      id: 6,
      name: "Dinner",
    },
    {
      id: 7,
      name: "Medication",
    },
    {
      id: 8,
      name: "TV",
    },
    {
      id: 9,
      name: "Reading",
    },
    {
      id: 10,
      name: "Talk to family and friends",
    },
    {
      id: 11,
      name: "Career Visit",
    },
    {
      id: 12,
      name: "Walk",
    },
    {
      id: 13,
      name: "Nap",
    },
  ];
};

export const timeOptions = () => {
  return [
    {
      id: 1,
      name: "12:00 AM",
    },
    {
      id: 2,
      name: "12:30 AM",
    },
    {
      id: 3,
      name: "1:00 AM",
    },
    {
      id: 4,
      name: "1:30 AM",
    },
    {
      id: 5,
      name: "2:00 AM",
    },
    {
      id: 6,
      name: "2:30 AM",
    },
    {
      id: 7,
      name: "3:00 AM",
    },
    {
      id: 8,
      name: "3:30 AM",
    },
    {
      id: 9,
      name: "4:00 AM",
    },
    {
      id: 10,
      name: "4:30 AM",
    },
    {
      id: 11,
      name: "5:00 AM",
    },
    {
      id: 12,
      name: "5:30 AM",
    },
    {
      id: 13,
      name: "6:00 AM",
    },
    {
      id: 14,
      name: "6:30 AM",
    },
    {
      id: 15,
      name: "7:00 AM",
    },
    {
      id: 16,
      name: "7:30 AM",
    },
    {
      id: 17,
      name: "8:00 AM",
    },
    {
      id: 18,
      name: "8:30 AM",
    },
    {
      id: 19,
      name: "9:00 AM",
    },
    {
      id: 20,
      name: "9:30 AM",
    },
    {
      id: 21,
      name: "10:00 AM",
    },
    {
      id: 22,
      name: "10:30 AM",
    },
    {
      id: 23,
      name: "11:00 AM",
    },
    {
      id: 24,
      name: "11:30 AM",
    },
    {
      id: 25,
      name: "12:00 PM",
    },
    {
      id: 26,
      name: "12:30 PM",
    },
    {
      id: 27,
      name: "1:00 PM",
    },
    {
      id: 28,
      name: "1:30 PM",
    },
    {
      id: 29,
      name: "2:00 PM",
    },
    {
      id: 30,
      name: "2:30 PM",
    },
    {
      id: 31,
      name: "3:00 PM",
    },
    {
      id: 32,
      name: "3:30 PM",
    },
    {
      id: 33,
      name: "4:00 PM",
    },
    {
      id: 34,
      name: "4:30 PM",
    },
    {
      id: 35,
      name: "5:00 PM",
    },
    {
      id: 36,
      name: "5:30 PM",
    },
    {
      id: 37,
      name: "6:00 PM",
    },
    {
      id: 38,
      name: "6:30 PM",
    },
    {
      id: 39,
      name: "7:00 PM",
    },
    {
      id: 40,
      name: "7:30 PM",
    },
    {
      id: 41,
      name: "8:00 PM",
    },
    {
      id: 42,
      name: "8:30 PM",
    },
    {
      id: 43,
      name: "9:00 PM",
    },
    {
      id: 44,
      name: "9:30 PM",
    },
    {
      id: 45,
      name: "10:00 PM",
    },
    {
      id: 46,
      name: "10:30 PM",
    },
    {
      id: 47,
      name: "11:00 PM",
    },
    {
      id: 48,
      name: "11:30 PM",
    },
  ];
};

export const colorOptions = () => {
  return [
    {
      id: 1,
      name: "Red",
    },
    {
      id: 2,
      name: "Blue",
    },
    {
      id: 3,
      name: "Yellow",
    },
    {
      id: 4,
      name: "Green",
    },
    {
      id: 5,
      name: "Black",
    },
    {
      id: 6,
      name: "Purple",
    },
    {
      id: 7,
      name: "White",
    },
    {
      id: 8,
      name: "Gray",
    },
    {
      id: 9,
      name: "Brown",
    },
    {
      id: 10,
      name: "Pink",
    },
  ];
};

export const sleepOptions = () => {
  let sleeps = [];
  for (let i = 0; i <= 24; i++) {
    sleeps.push({ id: i, name: i });
  }
  return sleeps;
};

export const exerciseOptions = () => {
  return [
    {
      id: 1,
      name: "Everyday",
    },
    {
      id: 2,
      name: "Weekly",
    },
    {
      id: 3,
      name: "Occasionally",
    },
    {
      id: 4,
      name: "Not at All",
    },
  ];
};

export const walkOptions = () => {
  return [
    {
      id: 1,
      name: "Everyday",
    },
    {
      id: 2,
      name: "Weekly",
    },
    {
      id: 3,
      name: "Occasionally",
    },
    {
      id: 4,
      name: "Not at All",
    },
  ];
};

export const mileOptions = () => {
  let miles = [];
  for (let i = 0; i <= 30; i++) {
    miles.push({ id: i, name: i });
  }
  return miles;
};

export const medicationOptions = () => {
  return [
    {
      id: 1,
      name: "Regularly",
    },
    {
      id: 2,
      name: "Do miss occasionally",
    },
    {
      id: 3,
      name: "Does not follow the Prescriptions",
    },
    {
      id: 4,
      name: "Forget to take Medication",
    },
    {
      id: 5,
      name: "Do not like to take Medication",
    },
  ];
};

export const hobbyOptions = () => {
  return [
    {
      id: 1,
      name: "Watching TV",
    },
    {
      id: 2,
      name: "Reading Books",
    },
    {
      id: 3,
      name: "Going to Clubs",
    },
    {
      id: 4,
      name: "Going to Pub",
    },
    {
      id: 5,
      name: "Meeting the Family",
    },
    {
      id: 6,
      name: "Pet Dogs",
    },
  ];
};

export const adminFilters = () => {
  return [
    {
      id: 1,
      name: "Username",
    },
  ];
};

export const frequencyOptions = () => {
  return [
    {
      id: 1,
      name: "Everyday",
    },
    {
      id: 2,
      name: "Specific day",
    },
  ];
};

export const startTimeOptions = () => {
  return [
    {
      id: 1,
      name: "00:00",
    },
    {
      id: 2,
      name: "00:15",
    },
    {
      id: 3,
      name: "00:30",
    },
  ];
};

export const countOptions = () => {
  let counts = [];
  for (let i = 1; i <= 24; i++) {
    counts.push({
      id: i,
      name: i,
    });
  }
  return counts;
};

export const remindMeOptions = () => {
  return [
    {
      id: 1,
      name: "0 Mins",
    },
    {
      id: 2,
      name: "15 Mins",
    },
    {
      id: 3,
      name: "30 Mins",
    },
  ];
};

// Dashboard Module
export const users = () => {
  return [
    {
      id: 1,
      name: "Peter",
      email: "peter@cosmaonline.com",
    },
    {
      id: 2,
      name: "Finn Larson",
      email: "finnLarson@cosmaonline.com",
    },
    {
      id: 3,
      name: "Elan Musk",
      email: "elanmusk@cosmaonline.com",
    },
    {
      id: 4,
      name: "Admin",
      email: "admin@cosmaonline.com",
    },
  ];
};

export const userOptions = () => {
  return users().map((ele) => {
    return {
      id: ele.id,
      name: ele.email,
    };
  });
};

export const reportOptions = () => {
  return [
    {
      id: 1,
      name: "Today",
    },
    {
      id: 2,
      name: "Last Week",
    },
    {
      id: 3,
      name: "Last Month",
    },
    {
      id: 4,
      name: "Last Year",
    },
    {
      id: 5,
      name: "Datewise",
    },
  ];
};

export const categories = () => {
  return [
    {
      id: 1,
      name: "Attention",
      icon: "work",
      color: "primary",
      count: 0,
      insight: "Your ability to focus and filter distractions. Strong attention supports safe daily tasks like managing medication and following conversations.",
      trendHigh: "Focus is strong — daily tasks remain manageable and concentration is well preserved.",
      trendMid: "Some lapses in focus detected — reducing distractions during tasks may help.",
      trendLow: "Declining attention may affect concentration and increase errors in daily activities.",
    },
    {
      id: 2,
      name: "Language",
      icon: "translate",
      color: "secondary",
      count: 0,
      insight: "How well you find words, understand speech and communicate. Language underpins social connection, independence and emotional wellbeing.",
      trendHigh: "Communication is well preserved — word finding and comprehension remain strong.",
      trendMid: "Occasional word-finding difficulties noted — social engagement and reading can help.",
      trendLow: "Word-finding difficulties may be increasing — speech and language therapy may be beneficial.",
    },
    {
      id: 3,
      name: "Memory",
      icon: "folder-mydrive",
      color: "info",
      count: 0,
      insight: "Your ability to store and recall past experiences, learned facts and familiar faces. Memory connects you to your identity and relationships.",
      trendHigh: "Memory recall is holding steady — personal history and daily routines are well retained.",
      trendMid: "Some memory gaps detected — structured routines and written reminders can support recall.",
      trendLow: "Memory lapses are increasing — consider reminders, routine structure and caregiver support.",
    },
    {
      id: 4,
      name: "Orientation",
      icon: "autorenew",
      color: "success",
      count: 0,
      insight: "Awareness of the current date, time, location and the people around you. Orientation supports safe and independent living day to day.",
      trendHigh: "Well oriented to time, place and person — daily independence is supported.",
      trendMid: "Mild orientation difficulties noted — calendars and familiar cues can help anchor awareness.",
      trendLow: "Orientation difficulties may increase risk of confusion, disorientation or getting lost.",
    },
    {
      id: 5,
      name: "Reaction Time",
      icon: "timer-sand",
      color: "warning",
      count: 0,
      insight: "How quickly your brain processes and responds to situations. Faster reaction times mean safer, more confident movement and decision making.",
      trendHigh: "Processing speed is good — responses remain quick and accurate.",
      trendMid: "Slightly slower responses detected — allow extra time for decisions and movements.",
      trendLow: "Slower reaction times noted — take extra care in fast-moving or high-risk situations.",
    },
    {
      id: 6,
      name: "Visual Memory",
      icon: "settings-input-svideo",
      color: "error",
      count: 0,
      insight: "Your ability to recognise faces, objects and visual patterns. Strong visual memory supports navigation, recognition of loved ones and daily safety.",
      trendHigh: "Visual recognition is intact — faces and familiar objects are well identified.",
      trendMid: "Some visual recognition challenges emerging — familiar labels and photos can support recall.",
      trendLow: "Visual recognition difficulties may be increasing — environmental cues and labels may help.",
    },
    {
      id: 7,
      name: "Visuospatial",
      icon: "grid_view",
      color: "info",
      count: 0,
      insight: "Understanding space, distance and shapes around you. This skill supports safe navigation, dressing, using utensils and household tasks.",
      trendHigh: "Spatial awareness is well maintained — navigation and spatial tasks remain confident.",
      trendMid: "Some spatial difficulties noted — familiar environments and clear layouts can help.",
      trendLow: "Spatial difficulties may affect navigation of familiar routes and fine motor tasks.",
    },
    {
      id: 8,
      name: "Executive Functions",
      icon: "account_tree",
      color: "warning",
      count: 0,
      insight: "Planning, decision making and problem solving. Executive function helps manage finances, medications, daily planning and adapting to change.",
      trendHigh: "Planning and decision making remain intact — complex tasks are being handled well.",
      trendMid: "Some difficulty with multi-step planning detected — checklists and routines can support.",
      trendLow: "Planning challenges may need structured support — simplifying tasks and routines is advised.",
    },
  ];
};

export const longTermMemory = () => {
  return [
    {
      id: 1,
      name: "Episodic",
      icon: "memory",
      color: "primary",
      count: 10,
    },
    {
      id: 2,
      name: "Procedural",
      icon: "memory",
      color: "secondary",
      count: 5,
    },
    {
      id: 3,
      name: "Semantic",
      icon: "memory",
      color: "warning",
      count: 30,
    }
  ];
};

export const shortTermMemory = () => {
  return [
    {
      id: 1,
      name: "Working",
      icon: "memory",
      color: "primary",
      count: 20,
    },
    {
      id: 2,
      name: "Spatial",
      icon: "memory",
      color: "secondary",
      count: 10,
    }
  ];
};

// Chart insight descriptions — keyed by category/subcategory name (lowercase)
export const chartInsights = {
  // ── Top-level categories ─────────────────────────────────────────────────
  attention:
    "Tracks your overall ability to focus and sustain concentration over the selected period. Consistent scores indicate preserved attentional control for daily tasks.",
  language:
    "Shows how well word-finding, verbal fluency and comprehension are maintained over time. Stable scores reflect preserved communication and social connection.",
  memory:
    "An overview of memory performance across both long-term and short-term domains. This chart helps identify whether recall is improving, stable or declining.",
  orientation:
    "Reflects awareness of time, place and person over the selected period. Consistent scores support safe, independent living day to day.",
  "reaction time":
    "Shows how quickly the brain processes and responds to stimuli over time. Faster, consistent scores indicate preserved processing speed and safer movement.",
  "visual memory":
    "Tracks the ability to recognise faces, objects and visual patterns. Stable scores support navigation, recognition of loved ones and daily safety.",
  visuospatial:
    "Reflects performance in understanding space, distance and shape relationships over time. Strong scores support safe navigation and fine motor tasks.",
  "executive functions":
    "Tracks planning, decision making and problem-solving ability. Consistent scores indicate the brain is managing complex multi-step tasks effectively.",

  // ── Memory subcategories ─────────────────────────────────────────────────
  "long term":
    "Aggregated trend across all long-term memory types. Long-term memory anchors personal identity — who you are, what you know, and how to do things.",
  "long term memory":
    "Aggregated trend across all long-term memory types. Long-term memory anchors personal identity — who you are, what you know, and how to do things.",
  "short term":
    "Aggregated trend across short-term and working memory. Short-term memory holds information in mind for immediate use, supporting reasoning and learning.",
  "short term memory":
    "Aggregated trend across short-term and working memory. Short-term memory holds information in mind for immediate use, supporting reasoning and learning.",

  // ── Long-term memory sub-sub categories ──────────────────────────────────
  "episodic memory":
    "Episodic memory stores personal life events — holidays, conversations, milestones. It lets you mentally travel back in time and is one of the earliest areas affected in dementia.",
  "procedural memory":
    "Procedural memory encodes how to perform learned skills — dressing, cooking, playing an instrument. These deeply ingrained routines are typically preserved well into later stages of cognitive decline.",
  "semantic memory":
    "Semantic memory holds general world knowledge — the meaning of words, facts, and concepts. It underpins communication and helps people engage meaningfully in conversation.",

  // ── Short-term memory sub-sub categories ─────────────────────────────────
  "working memory":
    "Working memory holds and manipulates information in the moment — following instructions, doing mental arithmetic, keeping track of a conversation. It is essential for independent daily functioning.",
  "working spatial memory":
    "Working spatial memory tracks the position of objects and people in space during an ongoing task. It supports safe movement around the home, navigation and spatial reasoning.",

  // ── Attention subcategories ───────────────────────────────────────────────
  "sustained attention":
    "The ability to maintain focus on a single task over an extended period. Decline here often shows up first as difficulty finishing tasks, losing track of conversations or missing important details.",
  "selective attention":
    "The ability to focus on relevant information while ignoring distractions. Strong selective attention helps people stay on task in busy environments like shops, kitchens or group settings.",
  "divided attention":
    "The ability to handle two or more tasks simultaneously. Divided attention supports complex daily activities such as cooking while monitoring the time, or walking while talking.",

  // ── Language subcategories ────────────────────────────────────────────────
  naming:
    "The ability to recall the correct name for objects, people and concepts. Word-finding difficulty (anomia) is a common early sign of cognitive decline and can lead to frustration in conversation.",
  "verbal fluency":
    "The ability to generate words quickly within a category (e.g., animals, foods). Verbal fluency reflects the speed and efficiency of language retrieval and is a sensitive marker of cognitive health.",
  comprehension:
    "The ability to understand spoken and written language. Good comprehension is essential for following medical instructions, understanding conversations and maintaining social relationships.",

  // ── Orientation subcategories ─────────────────────────────────────────────
  "time orientation":
    "Awareness of the current day, date, month and year. Time disorientation is often one of the first noticeable signs of cognitive decline and can affect medication management and daily scheduling.",
  "place orientation":
    "Awareness of where you are — the building, town or country. Preserved place orientation supports safe independent travel and reduces the risk of getting lost.",
  "person orientation":
    "The ability to recognise and correctly identify familiar people. Maintained person recognition supports meaningful social relationships and communication with family, friends and carers.",

  // ── Reaction Time subcategories ───────────────────────────────────────────
  "simple reaction time":
    "Response speed to a single, predictable stimulus. Simple reaction time reflects basic neural processing speed and is linked to fall risk and driving safety.",
  "choice reaction time":
    "Response speed when choosing between multiple possible actions. Choice reaction time involves decision making alongside speed and reflects real-world situations like crossing a road safely.",

  // ── Visual Memory subcategories ───────────────────────────────────────────
  "face recognition":
    "The ability to recognise familiar faces. Face recognition is deeply personal — difficulty here can be distressing for both the individual and their family.",
  "object recognition":
    "The ability to identify and name everyday objects visually. Object recognition supports safe use of household items and reduces confusion in familiar environments.",
  "pattern recognition":
    "The ability to identify and recall visual patterns. Pattern recognition underpins reading, number tasks and navigating visual environments.",

  // ── Visuospatial subcategories ────────────────────────────────────────────
  "spatial navigation":
    "The ability to find your way around familiar and unfamiliar environments. Spatial navigation decline is a significant safety concern and one of the earliest manifestations of Alzheimer's disease.",
  "depth perception":
    "The ability to judge distances accurately. Impaired depth perception increases the risk of falls and accidents in daily activities such as climbing stairs or pouring liquids.",
  construction:
    "The ability to assemble, arrange or draw objects correctly. Constructional ability reflects visuospatial integration and is commonly assessed in cognitive screening.",

  // ── Executive Functions subcategories ─────────────────────────────────────
  planning:
    "The ability to set goals, organise steps and carry out multi-stage tasks. Planning supports financial management, medication compliance, cooking and most complex daily activities.",
  "decision making":
    "The ability to weigh options and choose appropriate actions. Decision-making decline can lead to poor financial choices, missed appointments and difficulty managing risk.",
  "problem solving":
    "The ability to identify a problem and find an effective solution. Problem-solving is fundamental to independence and adapting to unexpected situations at home or in the community.",
  flexibility:
    "Cognitive flexibility — the ability to switch between tasks or adjust thinking when circumstances change. Reduced flexibility often shows as rigidity, repetition or difficulty coping with change.",
  inhibition:
    "The ability to suppress automatic responses and focus on relevant information. Inhibition supports safety by preventing impulsive actions and filtering out irrelevant stimuli.",
};

export const getChartInsight = (name) => {
  if (!name) return null;
  return chartInsights[name.toLowerCase().trim()] || null;
};

export const lineChart = (label) => {
  return {
    labels: ["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    datasets: { label, data: [50, 40, 300, 320, 500, 350, 200, 230, 500] },
  };
};

export const donutChart = () => {
  return {
    labels: ["Long Term Memory", "Short Term Memory"],
    datasets: {
      label: "Memories",
      backgroundColors: ["success", "info"],
      data: [15, 20],
    },
  };
};

export const licenceOptions = () => {
  return [
    {
      id: 1,
      name: "Licence Option 1",
    },
    {
      id: 2,
      name: "Licence Option 2",
    }
  ];
};